import { GET_GST_CERT_LIST_FAILURE, GET_GST_CERT_LIST_REQUEST, GET_GST_CERT_LIST_RESET, GET_GST_CERT_LIST_SUCCESS } from "../../actions";
const initialState = {
    data: null,
    isLoading: false,
    error: null,
};
const getGSTCertificateListReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_GST_CERT_LIST_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null });
        case GET_GST_CERT_LIST_SUCCESS:
            return Object.assign(Object.assign({}, state), { data: action.payload, isLoading: false, error: null });
        case GET_GST_CERT_LIST_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload });
        case GET_GST_CERT_LIST_RESET:
            return Object.assign({}, initialState);
        default:
            return state;
    }
};
export default getGSTCertificateListReducer;
